/**
 * Monthly bar chart — ported from the design prototype (business-report.js
 * `bars()`). Pure CSS: one flex column per month with the mono value on top,
 * a bottom-aligned bar with the `reportBarIn` entry animation, and the month
 * label underneath. Replaces the Chart.js `<Bar>` — same data, exact design,
 * fully token-themed.
 */

export interface BarDatum {
  label: string;
  value: number;
}

export default function Bars({
  data,
  format,
  color = 'var(--report-blue)',
  height = 230,
}: {
  data: BarDatum[];
  format: (v: number) => string;
  color?: string;
  height?: number;
}) {
  if (data.length === 0) return null;
  const max = Math.max(...data.map((d) => d.value)) * 1.12 || 1;

  return (
    <div
      className="grid grid-flow-col auto-cols-fr items-end gap-2.5"
      style={{ height }}
      role="img"
      aria-label="Bar chart"
    >
      {data.map((d, i) => (
        <div key={`${d.label}-${i}`} className="flex h-full flex-col items-center gap-1.5">
          <div className="font-mono text-[11px] tabular-nums text-muted-foreground">
            {format(d.value)}
          </div>
          <div className="flex w-full flex-1 items-end justify-center">
            <i
              className="report-bar-in block min-h-[2px] w-full max-w-[54px] rounded-t-md rounded-b-[2px]"
              style={{ height: `${((d.value / max) * 100).toFixed(1)}%`, background: color }}
            />
          </div>
          <div className="font-mono text-[11px] text-muted-foreground">{d.label}</div>
        </div>
      ))}
    </div>
  );
}
